import { motion, AnimatePresence } from "framer-motion";
import { X, Headset } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

export default function VRModal({ open, onClose, onRequest }) {
    const { t } = useT();
    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-50 bg-charcoal/80 backdrop-blur-md flex items-center justify-center p-6"
                    onClick={onClose}
                    data-testid="vr-modal"
                >
                    <motion.div
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.95, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="relative bg-charcoal-surface border border-white/10 max-w-lg w-full p-10"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={onClose}
                            className="absolute top-5 right-5 text-white/60 hover:text-white"
                            data-testid="vr-modal-close"
                        >
                            <X size={20} />
                        </button>
                        <div className="w-14 h-14 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center mb-6">
                            <Headset className="text-gold" size={22} />
                        </div>
                        <div className="text-[11px] tracking-[0.4em] uppercase text-gold mb-3">
                            {t("vr.overline")}
                        </div>
                        <h3 className="font-display text-3xl font-semibold tracking-tight">
                            {t("vr.heading")}
                        </h3>
                        <p className="mt-4 text-white/60">
                            {t("vr.body")}
                        </p>
                        <button
                            onClick={onRequest}
                            className="mt-8 w-full bg-gold text-charcoal py-4 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-gold-hover transition-colors"
                            data-testid="vr-modal-request-btn"
                        >
                            {t("vr.cta")}
                        </button>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
